<!--
/*******************************************************************************
*@ 컴포넌트명   : cbmnetTrsaccRsultInqDtl1.vue
*@ 컴포넌트설명 : cbmnet2 타행이체 - 이체 상세내용
*@ 사용전문     :  
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="transfer">
    <popup
      :opened.sync="openData"
      :use-header="true"
      :use-footer="true"
      class="popup"
      @cancel="popupClose"
    >
      <template #subtitle>
        <h2>{{ /*신청 상세 내용*/ $t("MPAY-04-01-10-22") }}</h2>
      </template>
      <template #content>
        <div class="divider">
          <span
            class="divider-date"
          >{{ /*신청 일시*/ $t("MPAY-04-01-11-02") }} : {{$getGlobalDateFmt(_.padEnd(detailInfo.tranTimeCCT, 20, " "))}}</span>
        </div>
        <div class="cont-tit">
          <h6>{{ /*이체 결과*/ $t("MPAY-04-01-13-03") }}</h6>
        </div>
        <dl class="dlist dlist-item--type6">
          <dt>{{ /* 이체 구분 */ $t("MPAY-04-01-12-04") }}</dt>
          <dd class="right">{{ /* 타행 이체 */ $t("MINQ-01-01-06-18") }}</dd>
          <dt>{{ /*신청 일시*/ $t("MPAY-04-01-07-02") }}</dt>
          <dd class="right">{{ $getGlobalDateFmt(detailInfo.tranYmdCCT) }}</dd>
          <dt>{{ /*처리상태*/ $t("MPAY-04-01-11-17") }}</dt>
          <dd class="right">{{ detailInfo.tranStusCtntCCT }}</dd>
        </dl>
        <!-- <template v-if="siteCode == $config.SITECODE_OGHCM && detailInfo.rmtancPtrnDstcd!='03'">
          <div
            class="info info-etc-col"
          >{{ /*실제 거래 결과는 거래내역조회에서 하실 수 있습니다.*/"※ " + $t("MFXD-01-02-02-08")}}</div>
        </template>-->
        <div class="cont-tit">
          <h6>{{ /*출금 정보*/ $t("MPAY-04-01-12-09") }}</h6>
        </div>
        <dl class="dlist dlist-item--type6">
          <dt>{{ /*출금 계좌 번호*/ $t("MPAY-04-01-12-10") }}</dt>
          <dd class="right">{{ detailInfo.rmtancAcitmNoCCT }}</dd>
          <dt>{{ /*예금주명*/ $t( "MLON-01-01-11-05") }}</dt>
          <dd class="right">{{ detailInfo.rmtrNameCCT }}</dd>
          <dt>{{ /*출금 금액*/ $t("MPAY-04-01-12-12") }}</dt>
          <dd class="right">
            <span class="exchange-unit">MMK</span>
            <span class="amount">{{$num(detailInfo.tranAmtCCT)}}</span>
          </dd>
          <dt>{{ /*수수료*/ $t("MPAY-04-01-10-06") }}</dt>
          <dd class="right">
            <span class="exchange-unit">MMK</span>
            <span class="amount">{{$num(detailInfo.aplyFeeAmtCCT)}}</span>
          </dd>
          <dt>{{ /*송금목적*/ $t("PCOP-02-03-05-24") }}</dt>
          <dd
            class="right"
            v-if="(detailInfo.rmtancInfoCtntCCT).includes(':') && /^[A-Z0-9]{1}[0-9]{1}$/.test(detailInfo.rmtancInfoCtntCCT.split(':', 1))"
          >{{ $t(`${detailInfo.rmtancInfoCtntCCT.split(':', 1)}_송금목적구분_MMR2`) /* 송금목적구분_MMR2: 타행이체신청내역조회(_MMR: 인뱅기준/_MMR2: 단말기준) */ }}</dd>
          <dd class="right" v-else>{{ detailInfo.rmtancInfoCtntCCT }}</dd>
        </dl>
        <div class="cont-tit">
          <h6>{{ /*입금 정보*/ $t("MPAY-04-01-10-08") }}</h6>
        </div>
        <dl class="dlist dlist-item--type6">
          <template v-if="siteCode != $config.SITECODE_OGAUC">
            <dt>{{ /* 은행명 */ $t("MPAY-04-01-10-09") }}</dt>
            <dd class="right">{{ detailInfo.rcevnBnkNameCCT }}</dd>
          </template>
          <template v-if="siteCode==$config.SITECODE_OGMMR || siteCode == $config.SITECODE_OGIND">
            <dt>{{ /* 입금 지점 */ $t("MPAY-02-01-26-17") }}</dt>
            <dd class="right">{{ detailInfo.rcevnBrnNameCCT }}</dd>
          </template>
          <dt>{{ /*입금 계좌번호*/ $t("MPAY-04-01-10-10") }}</dt>
          <dd class="right">{{ detailInfo.draweAcitmNoCCT }}</dd>
          <dt>{{ /*입금 금액*/ $t("MPAY-04-01-10-11") }}</dt>
          <dd class="right">
            <span class="exchange-unit">MMK</span>
            <span class="amount">{{$num(detailInfo.tranAmtCCT)}}</span>
          </dd>
          <dt>{{ /*수취인*/ $t("MPAY-04-01-12-17") }}</dt>
          <dd class="right">{{ detailInfo.draweNameCCT }}</dd>
          <dt>{{ /*Particulars*//*수취인 참조내용*/ siteCode == $config.SITECODE_OGAUC ? $t("MPAY-02-01-12-22") : $t("MPAY-04-01-06-A14")}}</dt>
          <dd class="right">{{ detailInfo.memoCCT }}</dd>
        </dl>
      </template>
      <template #footer>
        <button
          class="btn bottom positive"
          @click="popupClose()"
        >{{ /*확인*/ $t("MPAY-04-01-12-19") }}</button>
      </template>
    </popup>
  </section>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    detailInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapFields(["siteCode", "operGroupCd"]),
    openData: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    popupClose() {
      this.openData = false;
      this.$emit("popupClose", false);
    },
  },
};
</script>
